export const RequiredWhen = (value, condition ) => {
    return condition && !value ? 'Field is required' : undefined;
}
